import axios from 'axios'
import Cookies from 'js-cookie'

const ENDPOINT_PATH = process.env.VUE_APP_API_URL

export default {
  setUserLogged (userLogged, token) {
    Cookies.set('userLogged', JSON.stringify(userLogged))
    Cookies.set('jwt-token', token)
  },
  closeSession() {
    Cookies.remove('userLogged')
    Cookies.remove('jwt-token')
  },
  getUserLogged () {
    const userLoggedString = Cookies.get('userLogged')
    return userLoggedString ? JSON.parse(userLoggedString) : null
  },
  hasUserPermission(permissionCode) {
    const userLogged = this.getUserLogged()
    return !!(userLogged && userLogged.permissions && userLogged.permissions.some(permission => permission.code === permissionCode))
  },
  hasUserProfile(profileDescription) {
    const userLogged = this.getUserLogged()
    return !!(userLogged && userLogged.profiles && userLogged.profiles.some(profile => profile.description === profileDescription))
  },
  canManageUsers () {
    return this.hasUserProfile('Usuario Admin')
  },
  canViewBirthdays () {
    return this.canManageUsers() || this.hasUserPermission('VIEW_BIRTHDAYS')
  },
  getTokenLogged () {
    return Cookies.get('jwt-token')
  },
  isLogged () {
    const token = this.getTokenLogged()
    if (token) return true
    this.closeSession()
    return false
  },
  register (email, password) {
    const user = { email, password }
    return axios.post(ENDPOINT_PATH + 'register', user)
  },
  login (email, password) {
    const user = { email, password }
    return axios.post(ENDPOINT_PATH + 'login', user)
  }
}

